<template>
  <div>
    <div v-if="timeLeft > 0" class="duration">
      <span>{{ days }}</span> 天
      <span>{{ hours }}</span> 时
      <span>{{ minutes }}</span> 分
      <span>{{ Math.floor(seconds) }}</span> 秒
    </div>
    <div v-else class="end">{{ label }}已截止</div>
  </div>
</template>
<script>
import DateUtils from '@/utils/date'
export default {
  props: {
    timeLeft: {
      type: [String, Number],
      default: ''
    },

    label: {
      type: String,
      default: ''
    }
  },

  computed: {
    days() {
      return DateUtils.formatDuring(this.timeLeft).days
    },
    hours() {
      return DateUtils.formatDuring(this.timeLeft).hours
    },
    minutes() {
      return DateUtils.formatDuring(this.timeLeft).minutes
    },
    seconds() {
      return DateUtils.formatDuring(this.timeLeft).seconds
    }
  }
}
</script>
<style lang="scss" scoped>
.duration{
  color: $third-text-color;
  span {
    color: $primary-color;
    line-height: 24px;
    font-size: 24px;
    margin: 0 6px;
  }
}
.end {
  font-size: 20px;
  color: $primary-color;
}
</style>